const Voucherfilds = [
  {
    id: Math.random() * 10,
    name: "Amount_Details1",
    fields: [
      {
        id: Math.random() * 10,
        name: `Account_Name${Math.random() * 10}`,
        label: "Opp.A/c",
        type: "InputDropForQuery",
        masterName: "All_Accounts",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        label: "Amount",
        type: "number",
        min: 0,
        max: 9,
        info: "Db",
        info2: "Cr",
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Amount_Details2",
    fields: [
      {
        id: Math.random() * 10,
        name: `Account_Name${Math.random() * 10}`,
        label: "Diff.A/C",
        type: "InputDropForQuery",
        masterName: "All_Accounts",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        label: "Amount",
        max: 9,
        type: "number",
        min: 0,
        info: "Db",
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Amount_Details3",
    fields: [
      {
        id: Math.random() * 10,
        name: `Account_Name${Math.random() * 10}`,
        label: "Diff.A/C 2",
        type: "InputDropForQuery",
        masterName: "All_Accounts",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        label: "Amount",
        type: "number",
        min: 0,
        max: 9,
        info: "Db",
      },
    ],
  },
];

const DocUpload = {
  name: "Documents",
  label: "Other Details",
  fields: [
    {
      id: Math.random() * 10,
      name: "File",
      label: "",
    },
  ],
};

const BankConfig = [
  {
    id: Math.random() * 10,
    name: "Account_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: `Bank_Account_Name`,
        label: "Bank",
        type: "InputDropForQuery",
        masterName: "Bank_And_Cash_Accounts",
        variable: { accountType: ["Bank And Cash Account"] },
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        label: "Amount",
        type: "number",
        min: 0,
        max: 9,
        info: "Cr",
        info2: "Db",
      },
    ],
  },
];

const CashConfig = [
  {
    id: Math.random() * 10,
    name: "Account_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: `Cash_Account_Name`,
        label: "Cash",
        type: "InputDropForQuery",
        masterName: "Bank_And_Cash_Accounts",
        variable: { accountType: ["Bank And Cash Account"] },
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Amount",
        label: "Amount",
        type: "number",
        min: 0,
        max: 9,
        info: "Cr",
        info2: "Db",
      },
    ],
  },
];

export { Voucherfilds, DocUpload, BankConfig, CashConfig };
